/**
 * Centralized constants for the PWA Handel application
 */

import { APP_CONFIG } from './app-config';

export const FUNCTIONS_BASE = APP_CONFIG.supabase.functionsUrl;

export const REQUEST_HEADERS = {
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache, no-store, must-revalidate',
};

/**
 * Guest shopping defaults
 * Single source of truth for guest spending limits
 */
export const GUEST_DEFAULTS = {
  /** Default spending limit in öre (20000 = 200 SEK) */
  SPENDING_LIMIT_ORE: 20000,
  /** Default currency */
  CURRENCY: 'SEK'
} as const;
